import React from 'react'

const ReviseIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={30}
            height={30}
            fill="none"
            {...props}
        >
            <rect width={30} height={30} fill="#fff" rx={3} />
            <g
                stroke="#8790A4"
                strokeLinecap="round"
                strokeLinejoin="round"
                clipPath="url(#a)"
            >
                <path d="M15.571 7.57H9.857a1.143 1.143 0 0 0-1.143 1.143V19l-1.143 3.428 4.572-1.142h9.143a1.143 1.143 0 0 0 1.142-1.143v-5.714" />
                <path d="m16.558 16.297-3.43.617.572-3.474 5.406-5.383a1.143 1.143 0 0 1 1.623 0l1.211 1.211a1.141 1.141 0 0 1 0 1.623l-5.383 5.406Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M7 7h16v16H7z" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default ReviseIcon